import { Dispatch } from '../components/architecture/frontend/index'
import {startWith, map } from 'rxjs/operators'
import { fromEvent } from 'rxjs'

Dispatch.getAction('view')
  .pipe(
    //startWith({type: 'home'})
  )
  .subscribe(e => Dispatch.nextState('view', e))

Dispatch.getAction('shipment.select')
    .pipe(
      
    )
    .subscribe(e => Dispatch.nextState('view', {type: 'newClaim'}))

  fromEvent(window, 'resize')
    .pipe(
      map(e => ({ height: window.innerHeight, width: window.innerWidth, ratio: window.devicePixelRatio, header: 56.5, extra: Math.random()})),
      startWith({ height: window.innerHeight, width: window.innerWidth, header: 56.5, ratio: window.devicePixelRatio})
    )
    .subscribe(e => Dispatch.nextState('ui.window', e ))

  // window.addEventListener('error', function(event) { this.alert('hiiii') })